<script setup>
import {useI18n} from "vue-i18n";
import {computed, inject} from "vue";


import edaTools from "@/lib/es-bill-shared-js/misc/edaTools";

import { useCommunitiesStore } from '@/stores/communitiesStore'
import { useMeteringPointMembershipsStore } from '@/stores/meteringPointMembershipsStore'

const communitiesStore = useCommunitiesStore();
const mpmStore = useMeteringPointMembershipsStore();
const { t } = useI18n();
const $log = inject('log');

const communitiesNoDsoNot16bOrEp = computed(() => {
  return communitiesStore.allCommunities.filter(c =>
    (!c.ecnDso || c.ecnDso.length===0) &&
    edaTools.isEcnValidExternal(c.ecn) &&
    c.communityType !== "16b" &&
    c.communityType !== "EP"
  )
})

const communitiesNotDemo = computed(() => {
  return communitiesStore.allCommunities.filter(c =>
    edaTools.isEcnValidExternal(c.ecn)
  )
})

const membershipsNotDemo = computed(() => {
  return mpmStore.allMeteringPointMemberships.filter(mpm =>
    edaTools.isEcnValidExternal(mpm.ecn))
})

function getLineForMpStatus(mpmStatus) {
  const countByState = membershipsNotDemo.value.filter(mpm => mpm.membershipStatus === mpmStatus).length;
  const countAll = membershipsNotDemo.value.length;

  return countByState+" ("+(Math.round(countByState*100/countAll))+"%)";
}


</script>


<template>
  <v-container class="containerBase pa-0">

    <v-container class="containerStandard">

      <p class="textHeadline">{{ $t('dashboard') }}</p>

      <v-divider class="divider"/>

      <div>
        <h2>Stats</h2>
        <u>Communities: {{ communitiesNotDemo.length }}</u><br>
        GEAs: {{ communitiesNotDemo.filter(c => c.communityType === "16a").length }}<br>
        BEGs: {{ communitiesNotDemo.filter(c => c.communityType === "16b").length }}<br>
        EEGs: {{ communitiesNotDemo.filter(c => c.communityType === "16c").length }}<br>
        EPs:  {{ communitiesNotDemo.filter(c => c.communityType === "EP").length }}<br>
        <br>

        <u>MPMs (sum, non-Demo): {{ membershipsNotDemo.length }}</u><br>
        CREATED:          {{ getLineForMpStatus("CREATED") }}<br>
        STARTED:          {{ getLineForMpStatus("STARTED") }}<br>
        WAITING_FOR_USER: {{ getLineForMpStatus("WAITING_FOR_USER") }}<br>
        ACCEPTED:         {{ getLineForMpStatus("ACCEPTED") }}<br>
        ACTIVE:           {{ getLineForMpStatus("ACTIVE") }}<br>
        ENDING:           {{ getLineForMpStatus("ENDING") }}<br>
        ENDED:            {{ getLineForMpStatus("ENDED") }}<br>
        DECLINED:         {{ getLineForMpStatus("DECLINED") }}<br>
      </div>


      <div>
        <br>
        <b>Communities (technical), no BEGs and no ECN for DSO set:</b>
        <ul class="listGeneric">
          <li v-for="community in communitiesNoDsoNot16bOrEp" :key="community.ecn">{{community.ecn}} {{community.name}}</li>
        </ul>

      </div>


      <div>
        <br>
        <b>Weitere Links</b><br>
        <ul class="listGeneric">
          <li><router-link to="/maintainers" class="routerLinkNoDecoration">
            Liste der Verwalter
          </router-link></li>
          <li><router-link to="/communities/analysis/badMeteringPoints" class="routerLinkNoDecoration">
            Neue Auswertungen SLR
          </router-link></li>
          <li><router-link to="/communities/ecpodlist" class="routerLinkNoDecoration">
            EC-Podlist anfordern (ANFORDERUNG_ECP)
          </router-link></li>
          <li><router-link to="/misc/camt-preview" class="routerLinkNoDecoration">
            Vorschau CAMT-Bankauszüge
          </router-link></li>
          <li><router-link to="/exports/energyDump" class="routerLinkNoDecoration">
            Export Energiedaten (Dump)
          </router-link></li>
        </ul>
      </div>

    </v-container>
  </v-container>
</template>

<script>

export default {
  name: 'HomeView',
}
</script>

<style>

.listGeneric {
  margin-left: 20px;
}

</style>
